export class Template {
    templateId: number;
    templateTitle: string;
    description: string;
    clientOwner?: number;
    templateTag: string;
    templateVersion: string;
    payerId: number;
    payerName?: string;
    formatId: number;
    customReportId: number;
    formatName?: string;
    startDate?: Date;
    endDate?: Date;
    riskTypeId?: number;
    riskTypeName?: string;
    isAttribution?: number;
    isAttributionName?: string;
    isPublished: boolean;
    createdBy: number;
    createdByName?: string;
    createdDate: Date;
    modifiedBy?: number;
    modifiedDate?: Date;
    modifiedByName?: string;
    totalGoals?: number;
    totalItems?: number;
}